import React, { AnchorHTMLAttributes, forwardRef } from 'react';
import Link, { LinkProps } from 'next/link';

type LinkBehaviorProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  keyof LinkProps
> &
  LinkProps & { href: string };

// 외부 링크인지 판별하는 간단한 유틸 함수
const isExternal = (href: string) =>
  /^((http|https|ftp):\/\/|mailto:|tel:)/.test(href);

const LinkBehavior = forwardRef<HTMLAnchorElement, LinkBehaviorProps>(
  (props, ref) => {
    const { href, ...other } = props;

    // 방어 코드: href가 없으면 그냥 a 태그 (또는 button)
    if (!href) {
      return <a ref={ref} {...other} />;
    }

    // 1. 외부 링크라면 -> 그냥 <a> 태그 사용 (Next/Link 안 거침)
    if (typeof href === 'string' && isExternal(href)) {
      return (
        <a
          ref={ref}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          {...other}
        />
      );
    }

    // 2. 내부 링크라면 -> Next/Link 사용 (Client-side Routing)
    return <Link ref={ref} href={href} {...other} />;
  },
);
LinkBehavior.displayName = 'LinkBehavior';

export default LinkBehavior;
